import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { swatchStyle } from '../data/sauledaColours';
import './ColourDetailModal.css';

// Enlarged view of a single colourway: the fabric weave photo (or the flat
// colour when no photo is set yet), the name, the Sauleda code, and a direct
// route into the quote form carrying the code.
//
// Shared by the /colours page and the compact grid on product pages so both
// behave identically.
export default function ColourDetailModal({ colour, onClose, isStock = false, stockNote }) {
  const closeRef = useRef(null);

  useEffect(() => {
    if (!colour) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    closeRef.current?.focus();
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [colour, onClose]);

  if (!colour) return null;

  return (
    <div className="cdm-backdrop" onClick={onClose}>
      <div
        className="cdm"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cdm-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button ref={closeRef} type="button" className="cdm-close" onClick={onClose} aria-label="Close">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            <path d="M18 6 6 18M6 6l12 12" strokeLinecap="round" />
          </svg>
        </button>

        <div
          className={`cdm-swatch${colour.stripes ? ' cdm-swatch--stripe' : ''}`}
          style={swatchStyle(colour, { repeatPx: 120 })}
          role="img"
          aria-label={`${colour.name} fabric`}
        />

        <div className="cdm-body">
          <p className="cdm-category">{colour.category}</p>
          <h2 className="cdm-title" id="cdm-title">{colour.name}</h2>
          <p className="cdm-code">Sauleda code: <strong>{colour.code}</strong></p>

          {isStock && stockNote && <p className="cdm-stock">{stockNote}</p>}

          {!colour.imageUrl && !colour.stripes && (
            <p className="cdm-note">
              Shown as a flat colour - screens vary, so ask us for the exact shade before
              you order.
            </p>
          )}

          <Link
            to={`/request-quote?colour=${encodeURIComponent(colour.code)}`}
            className="cdm-cta"
          >
            Request a quote in this colour
          </Link>
        </div>
      </div>
    </div>
  );
}
